// arrivals upcoming weeks 

export default {
    data() {
        return {
            currentweek: 0, 
            title: '',       
        }   
    },

    methods: {
        createBarData(arr_ty) {

            arr_ty = this.sortByKey(arr_ty, "index");
            let xvalues_ty = [], barcolors_ty = [],  bordercolors_ty = [], yvalues_ty = [], maxvalue_ty = 0, maxvalue = 0;
            this.currentweek = this.getCurrentWeekNum();            

            for (let i = 0; i < arr_ty.length; i++) {
                yvalues_ty.push(arr_ty[i].nr_arrivals)
                xvalues_ty.push(arr_ty[i].week);
                if (arr_ty[i].nr_arrivals > maxvalue_ty) {
                    maxvalue_ty = arr_ty[i].nr_arrivals;
                }
            }

            maxvalue = maxvalue_ty;

            var section = [];
            section[3] = maxvalue;
            section[2] = maxvalue - (maxvalue / 4);
            section[1] = maxvalue - (2 * (maxvalue / 4));
            section[0] = maxvalue / 4;

            for (let i = 0; i < arr_ty.length; i++) {

                //console.log(arr_ty[i].nr_arrivals);

                if(arr_ty[i].week == this.currentweek){
                    barcolors_ty.push("lightblue"); // ok     
                    bordercolors_ty.push("blue"); // ok         
                } else {
                    var found = false;
                    for (let t = 0; t < section.length; t++) {
                        if(!found){
                            if(arr_ty[i].nr_arrivals <= section[t]){
                                switch (t) {
                                    case 0:
                                        barcolors_ty.push("rgba(50,205,50,0.5)"); // ok  
                                        bordercolors_ty.push("rgb(50,205,50)"); // ok  
                                        found=true;
                                        break;
                                    case 1:
                                        barcolors_ty.push("rgba(60,179,113,0.5)"); // busy
                                        bordercolors_ty.push("rgb(60,179,113)"); // busy
                                        found=true;
                                        break;
                                    case 2:
                                        barcolors_ty.push("rgba(46,139,87,0.5)"); // really busy
                                        bordercolors_ty.push("rgb(46,139,87)"); // really busy
                                        found=true;
                                        break;
                                    case 3:
                                        barcolors_ty.push("rgba(0,128,0,0.5)"); // insane
                                        bordercolors_ty.push("rgb(0,128,0)"); // insane
                                        found=true;
                                        break;
                                }
                            }
                        }
                    }
                }
            }

            let datasets = [];
            var currentYear = new Date().getFullYear();

            let dataset_element = {
                backgroundColor: barcolors_ty,
                hoverBackgroundColor: "rgba(34,139,34,0.3)",
                data: yvalues_ty,
                borderColor: bordercolors_ty,
                hoverBorderColor: "rgba(34,139,34,1)",
                label: "Arrivals " + currentYear,
                borderWidth: 2,
            };
            datasets.push(dataset_element);

            /*  scales
                hoogste waarde = 633
                633 - 633 mod 100 = 633 - 33 = 600
                600 / 100 = 6
                6 * 100 = 600
                600 + 100 = 700 (afronden naar boven in een 100-tal)
            */

            let xoptions = {
                plugins: { 
                    legend: { 
                        display: false 
                    },
                    tooltip: { 
                        enabled:false 
                    },            
                    datalabels: {
                        color: '#FF00000', 
                        anchor: 'end',
                        align: 'top',
                        font: {
                            size: 10,
                            weight: 'bold'
                        },
                        formatter: function(value, context){
                            return context !== null ? value === 0 ? '' : ''+value : 'ERR';                         
                        }
                    }                 
                },
                responsive: true,
                maintainAspectRatio: false,
                lineTension: 1,
                scales: 
                { 
                    y : { min: 0, max: this.getMaxValue(maxvalue)}
                },
                onClick: (evt) => {
                    // we have the event so we can get to some basic info (see console)
                    // console.log('x', evt.x, 'y', evt.y)
                    // intersect: true is needed to perform ONLY the action if clicked INSIDE a chart element
                    const x = this.chart.getElementsAtEventForMode(evt, 'nearest', {intersect: true}, true)
                    // you could have multiple datasets in a single chart. This way we can get the correct dataset from which the data comes of the element we clicked in
                    if(typeof x[0]!=='undefined'){
                        const dataset = x[0].datasetIndex
                        const datapoint = x[0].index // this will get the index of the element and we can get the label with this.
                        if(this.chart.data!==null) {
                            console.log(dataset, datapoint, this.chart.data.labels[datapoint])
                            this.week = this.chart.data.labels[datapoint]
                            this.open = true                        
                            this.showDrillDown(evt.x, evt.y)
                        }    
                    }
                },
                // onHover: (evt) => {
                //     // const x = this.chart.getElementsAtEventForMode(evt, 'nearest', {intersect: true}, true)
                //     // if(typeof x[0]!=='undefined') console.log(this.chart.data.labels[x[0].index])
                // }
            };

            let chartData = {
                type: 'bar',
                data: {
                    labels: xvalues_ty,
                    datasets: datasets,
                },
                options: xoptions,
            };            

            var idx = this.findWithAttr(arr_ty, "week",this.currentweek)
            this.title = "Week " + this.currentweek + " - " + this.arrivals[idx].nr_arrivals + " arrivals";

            return chartData;

        },
        getMaxValue(v){
            if(v - (((v - v%100) / 100) * 100) <= 50)
                return (((v - v%100) / 100) * 100) + 100
            return ((((v + 100) - v%100) / 100) * 100) + 100
        },
        getCurrentWeekNum(){
            /*
            var currentDate = new Date();
            var startDate = new Date(currentDate.getFullYear(), 0, 1);
            var days = Math.floor((currentDate - startDate) / (24 * 60 * 60 * 1000));                
            return Math.ceil(days / 7);
            */
            var date = new Date();
            date.setHours(0, 0, 0, 0);
            // Thursday in current week decides the year.
            date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
            // January 4 is always in week 1.
            var week1 = new Date(date.getFullYear(), 0, 4);
            // Adjust to Thursday in week 1 and count number of weeks from date to week1.
            return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
                                  - 3 + (week1.getDay() + 6) % 7) / 7);           
        },
        sortByKey(array, key) {
            return array.sort(function(a, b) {
                var x = a[key]; var y = b[key];
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });
        },     
        findWithAttr(array, attr, value) {
            for(var i = 0; i < array.length; i += 1) {
                if(array[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        },            
    }
}